import { useLayoutEffect, useRef } from 'react';

/**
 * Champ texte qui grandit avec ce qu'on y écrit (jamais de barre de défilement dans le champ, jamais de poignée à tirer).
 * La hauteur suit le contenu à chaque frappe et quand la largeur change (fenêtre redimensionnée).
 */
export function TexteAdaptatif({ valeur, onChange, onBlur, id, etiquette, placeholder, minLignes = 2, maxLength, disabled, classe }: {
  valeur: string; onChange: (v: string) => void; onBlur?: () => void; id: string; etiquette: string; placeholder?: string;
  minLignes?: number; maxLength?: number; disabled?: boolean; classe?: string;
}) {
  const ref = useRef<HTMLTextAreaElement>(null);

  function ajuster() {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight + 2}px`;
  }

  useLayoutEffect(ajuster, [valeur]);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    let largeur = el.offsetWidth;
    const obs = new ResizeObserver(() => { if (el.offsetWidth !== largeur) { largeur = el.offsetWidth; ajuster(); } });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <textarea
      ref={ref}
      id={id}
      className={`form-textarea texte-adaptatif${classe ? ` ${classe}` : ''}`}
      aria-label={etiquette}
      rows={minLignes}
      value={valeur}
      placeholder={placeholder}
      maxLength={maxLength}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
    />
  );
}
